import { type VariantProps, cva } from 'class-variance-authority';

const toastVariants = cva(
  'group pointer-events-auto relative flex w-full min-w-0 max-w-[26.25rem] items-center gap-4 overflow-hidden rounded-3xl border border-border/60 p-4 pr-6 shadow-2xl backdrop-blur-xl toast-animate sm:min-w-[20rem]',
  {
    variants: {
      variant: {
        default: 'border-border/60 bg-popover text-popover-foreground',
        destructive: 'border-destructive/40 bg-destructive/15 text-destructive-foreground',
        snapshot: 'max-w-[32.5rem] rounded-2xl border-0 bg-foundation-base-darkbase-dark-500 px-[18px] py-[14px] text-white shadow-2xl backdrop-blur-none sm:min-w-0'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

const toastTitleVariants = 'text-base font-semibold break-words';
const toastDescriptionVariants = 'text-sm text-muted-foreground break-words';

export { toastVariants, toastTitleVariants, toastDescriptionVariants };
export type ToastVariantProps = VariantProps<typeof toastVariants>;
